/* Логика анимации для секции панорамы + форма продукта

assets/new-product-section.js

*/

(function() {

// ========== АНИМАЦИЯ ПАНОРАМЫ ==========

//
// === ВЕРСИЯ ДЛЯ РУЧНОГО СКРОЛЛА ===
// (Используется вместе с CSS 'overflow-y: auto')
//

const initPanoramaAnimation = (section) => {
	if (!section) return;

	// Проверяем, загружены ли GSAP и ScrollTrigger
	if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
		console.warn('GSAP or ScrollTrigger not loaded. Animation will not work.');
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const panel = section.querySelector('.side-panel');
	if (!panel) {
		console.warn('Side panel not found. Animation stopped.');
		return;
	}

	// Получаем направление из data-атрибута
	const direction = section.dataset.slideDirection || 'right';
	let startXPercent, panelStartPos;

	// Определяем начальные CSS-свойства
	if (direction === 'left') {
		startXPercent = -100; // Начать за левым краем
		panelStartPos = { left: 0, right: 'auto' }; // Прикрепить панель к левой стороне
	} else { // 'right'
		startXPercent = 100; // Начать за правым краем
		panelStartPos = { left: 'auto', right: 0 }; // Прикрепить панель к правой стороне
	}

	// --- ОЧИСТКА ---
	// "Убиваем" все ScrollTrigger'ы, связанные с этой секцией
	ScrollTrigger.getAll().forEach(st => {
		if (st.trigger === section) {
			st.kill(true);
		}
	});

	// Сбрасываем все inline-стили, установленные GSAP
	gsap.set(panel, { clearProps: "all" });
	// Сбрасываем прокрутку панели в начало
	panel.scrollTop = 0;

	// --- НАСТРОЙКА АНИМАЦИИ ---
	// 1. Устанавливаем "статичное" положение панели (слева или справа)
	gsap.set(panel, panelStartPos);

	// 2. Устанавливаем "анимированное" начальное положение (за экраном)
	gsap.set(panel, { 
      xPercent: startXPercent,
      autoAlpha: 1 // <--- ДОБАВЬТЕ ЭТУ СТРОКУ
  });

	// 3. Создаем главную таймлайн (Timeline)
	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: section,
			pin: true,
			start: "top top",
			// Мы увеличили end, чтобы дать пользователю время на скролл
			end: "+=200%", 
			scrub: 1,
			// markers: true // Раскомментируйте для отладки
		}
	});

	// 4. Добавляем анимацию сдвига в таймлайн
	// Эта анимация займет 3 "части" времени
	tl.to(panel, {
		xPercent: 0,
		ease: "power1.inOut",
		duration: 3 // 3 "части" времени на анимацию
	});

	// 5. НОВЫЙ БЛОК: "Пауза" для мануального скролла
	// Эта пустая анимация "держит" pin активным,
	// давая пользователю время на скролл панели.
	// (Раньше здесь была анимация scrollTop)
	tl.to({}, {
		duration: 1 // 4 "части" времени на мануальный скролл
	});
};

// ========== ФОРМА ПРОДУКТА ==========

// Функция для инициализации формы продукта
const initProductForm = (section) => {
  if (!section) return;
  
  const form = section.querySelector('.product-form');
  if (!form) return;

  const priceElement = section.querySelector('.price');
  const variantIdInput = form.querySelector('input[name="id"]');
  const quantityInput = form.querySelector('input[name="quantity"]');
  const variantRadios = form.querySelectorAll('.js-variant-radio');
  const minusBtn = form.querySelector('.quantity__button[name="minus"]');
  const plusBtn = form.querySelector('.quantity__button[name="plus"]');
  const submitButton = form.querySelector('.product-form__submit');
  const buttonTextAvailable = submitButton?.querySelector('.button-text-available');
  const buttonTextUnavailable = submitButton?.querySelector('.button-text-unavailable');

  // Получаем данные о вариантах из JSON
  const productDataElement = section.querySelector('[data-product-json]');
  if (!productDataElement) {
    console.warn('Product data not found. Variant selection will not work.');
    return;
  }

  let productData;
  try {
    productData = JSON.parse(productDataElement.textContent);
    console.log('=== DEBUG INFO ===');
console.log('Product variants:', productData.variants);
if (productData.variants) {
  productData.variants.forEach((v, i) => {
    console.log(`Variant ${i}:`, v.title || v.option1, 'Available:', v.available);
  });
}
console.log('==================');

  } catch (e) {
    console.error('Error parsing product data:', e);
    return;
  }

  // Функция для поиска варианта по выбранной опции
  const findVariantByOption = (optionValue) => {
    if (!productData.variants) return null;
    return productData.variants.find(variant => {
      return variant.options.includes(optionValue);
    });
  };

  // Функция для обновления состояния кнопки
  const updateButtonState = (isAvailable) => {
    if (!submitButton) return;
    
    if (isAvailable) {
      submitButton.disabled = false;
      submitButton.classList.remove('disabled');
      if (buttonTextAvailable) buttonTextAvailable.style.display = '';
      if (buttonTextUnavailable) buttonTextUnavailable.style.display = 'none';
    } else {
      submitButton.disabled = true;
      submitButton.classList.add('disabled');
      if (buttonTextAvailable) buttonTextAvailable.style.display = 'none';
      if (buttonTextUnavailable) buttonTextUnavailable.style.display = '';
    }
  };

  // Обработчик изменения варианта
  const updateVariant = () => {
    const selectedOption = form.querySelector('.js-variant-radio:checked');
    
    if (!selectedOption) {
      // Если ничего не выбрано, проверяем есть ли хотя бы один доступный вариант
      if (productData.variants && productData.variants.length > 0) {
        const hasAvailable = productData.variants.some(v => v.available);
        updateButtonState(hasAvailable);
      } else {
        // Если нет вариантов вообще, блокируем кнопку
        updateButtonState(false);
      }
      return;
    }

    const variant = findVariantByOption(selectedOption.value);
    if (variant && variantIdInput) {
      variantIdInput.value = variant.id;
      // Обновляем состояние кнопки на основе доступности варианта
      updateButtonState(variant.available);
      if (priceElement) {
	// 1. Берем уже отформатированную цену из нашего JSON
	// (из поля "formatted_price", которое мы добавили в liquid)
	const formattedPrice = variant.formatted_price;
	
	// 2. Просто вставляем ее в HTML
	// (она уже содержит правильный символ и формат)
	if (formattedPrice) {
		priceElement.textContent = formattedPrice;
	}
}
    } else {
      // Если вариант не найден, блокируем кнопку
      updateButtonState(false);
    }
  };

  // Слушатели для radio-кнопок вариантов
  variantRadios.forEach(radio => {
    radio.addEventListener('change', updateVariant);
  });

  // Обработчики для кнопок количества
  if (minusBtn && quantityInput) {
    minusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });
  }

  if (plusBtn && quantityInput) {
    plusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const currentValue = parseInt(quantityInput.value) || 1;
      quantityInput.value = currentValue + 1;
    });
  }

  // ВАЖНО: Инициализация при загрузке
  updateVariant();
};


// ========== ОБРАБОТЧИКИ СОБЫТИЙ ==========

// Функция для поиска и инициализации всех секций на странице
const loadSections = () => {
    document.querySelectorAll('.panorama-section-wrapper').forEach(section => {
        initPanoramaAnimation(section);
        initProductForm(section);
    });
};

// Запускаем при первой загрузке страницы
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadSections);
} else {
    // Если DOM уже загружен, запускаем сразу
    loadSections();
}

// Слушаем события редактора Shopify
document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('panorama-section-wrapper')) {
        initPanoramaAnimation(event.target);
        initProductForm(event.target);
    }
});

document.addEventListener('shopify:section:reorder', loadSections);

document.addEventListener('shopify:section:select', (event) => {
    if (event.target.classList.contains('panorama-section-wrapper')) {
        initPanoramaAnimation(event.target);
        initProductForm(event.target);
    }
});

})();
